const { loadResource, loadResourcePath } = require("path/middleware")
const { hasStoreEnabled, getStoreUrl } = require("store/utils")
const LibraryResourceContainer =
  require("./components/LibraryResourceContainer").default
import {
  constructUrl,
  getResourceSlugId
} from "@pathwright/web/src/modules/utils/urls"

// redirect any "section"-agnostic URLs to the path, at least necessary
// for some links in emails (probably should be fixed on the backend)
const redirectToPath = ({ location }, replaceState) =>
  replaceState(`${location.pathname}path/`)

const onRouteToAbout = function (nextState, replaceState) {
  if (hasStoreEnabled()) {
    return replaceState(getStoreUrl(nextState.match.params.resourceSlug))
  }

  return loadResource(nextState)
}
const MISSING_RESOURCE_SECTION_RE = /\/library\/[a-zA-Z0-9_-]+\/$/
const MISSING_COMMUNITY_AREA_RE = /\/library\/[a-zA-Z0-9_-]+\/\d+\/community\/$/

const onEnterSection = (nextState, replaceState) => {
  const { section } = nextState.match.params

  switch (section) {
    case "about":
      return onRouteToAbout(nextState, replaceState)
    case "path":
      return loadResourcePath(nextState)
    case "community":
      // Ensure community has a selected area, defaulting to "discussion" if none set in url
      if (MISSING_COMMUNITY_AREA_RE.test(nextState.location.pathname)) {
        return replaceState({
          ...nextState.location,
          pathname: constructUrl(nextState.location.pathname, "/discussion/")
        })
      }
      return loadResource(nextState)
  }
}

const onLeaveSection = (nextState) => {
  if (nextState.match.params.section === "path") {
    App.getStore("path").action.exitViewAsLearner()
  }
}

export default {
  path: "/library/:resourceSlug/",
  component: LibraryResourceContainer,
  onEnter: ({ location, match }, replaceState) => {
    const { resource } = App.getStore("resource").getState()

    // Initial enter: only clear resource-store when entering route
    // for the first time. Prefer clearing onEnter rather than onLeave
    // as this allows for routing back to the same resource + is more likely
    // to avoid errors occurring when resource-store init flow is cut short
    // due to quick navigations away from route.
    if (
      resource &&
      resource.resourceSlug !== match.params.resourceSlug &&
      // Extra check against the resource.id to avoid inaccurate inequaltiy due to
      // the dynamic nature of the resource resourceSlug.
      resource.id !== getResourceSlugId(match.params.resourceSlug)
    ) {
      App.getStore("resource").action.clearSelectedResource()
    }

    // Fix for resource urls lacking a /<section>/
    if (MISSING_RESOURCE_SECTION_RE.test(location.pathname)) {
      return replaceState({
        ...location,
        pathname: constructUrl(location.pathname, "/about/")
      })
    }
  },
  childRoutes: [
    {
      path: ":section(\\d+)/", // legacy
      onEnter: redirectToPath
    },
    {
      path: ":section(about)/", // about
      onEnter: onEnterSection
    },
    {
      path: ":cohortId(\\d+)/:section/",
      onEnter: onEnterSection,
      onLeave: onLeaveSection,
      childRoutes: [
        ...require("./components/step/routes").default,
        ...require("./components/community/routes").default
      ]
    }
  ]
}
